document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-px-book]').forEach(book=>{
    const spreads=[...book.querySelectorAll('[data-px-spread]')];
    const root=book.closest('.px-book'); let i=0;
    const count=root?.querySelector('[data-px-count]');
    const show=n=>{i=(n+spreads.length)%spreads.length;spreads.forEach((s,x)=>s.classList.toggle('is-active',x===i));if(count)count.textContent=`${String(i+1).padStart(2,'0')} / ${String(spreads.length).padStart(2,'0')}`};
    root?.querySelector('[data-px-prev]')?.addEventListener('click',()=>show(i-1));
    root?.querySelector('[data-px-next]')?.addEventListener('click',()=>show(i+1));show(0);
  });
  document.querySelectorAll('[data-px-inspect]').forEach(el=>{
    const img=el.querySelector('img'); if(!img)return;let down=false,start=0,rot=0;
    const move=x=>{if(!down)return;rot+=(x-start)*.35;start=x;img.style.transform=`rotateY(${rot}deg) rotateZ(${Math.sin(rot/40)*1.2}deg)`};
    el.addEventListener('pointerdown',e=>{down=true;start=e.clientX;el.setPointerCapture(e.pointerId)});
    el.addEventListener('pointermove',e=>move(e.clientX));el.addEventListener('pointerup',()=>down=false);el.addEventListener('pointercancel',()=>down=false);
  });
});
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-product-recommendations]').forEach(async el=>{try{const r=await fetch(el.dataset.url);if(!r.ok)return;const t=await r.text();const d=document.createElement('div');d.innerHTML=t;const replacement=d.querySelector('.px-recs');if(replacement)el.replaceWith(replacement)}catch(e){}})});

/* Phase 5 — product media, variant selection and visitor-shaped recommendations */
(function(){
  const SIGNAL_KEY='preetProductSignalsV1';
  const MAX_SIGNALS=24;

  function readSignals(){
    try{return JSON.parse(localStorage.getItem(SIGNAL_KEY)||'[]')||[];}catch(e){return [];}
  }
  function writeSignals(items){
    try{localStorage.setItem(SIGNAL_KEY,JSON.stringify(items.slice(0,MAX_SIGNALS)));}catch(e){}
  }
  function handleFromUrl(url){
    try{
      const u=new URL(url,window.location.origin);
      const match=u.pathname.match(/\/products\/([^/?#]+)/);
      return match?decodeURIComponent(match[1]):'';
    }catch(e){return '';}
  }
  function mergeSignal(data,kind){
    if(!data||!data.handle)return;
    const items=readSignals();
    const index=items.findIndex(item=>item.handle===data.handle);
    const existing=index>-1?items.splice(index,1)[0]:{};
    const merged=Object.assign({},existing,data,{lastSeen:Date.now()});
    merged.views=(existing.views||0)+(kind==='view'?1:0);
    merged.clicks=(existing.clicks||0)+(kind==='click'?1:0);
    items.unshift(merged);writeSignals(items);
  }
  function parseJson(el){
    if(!el)return null;
    try{return JSON.parse(el.textContent);}catch(e){return null;}
  }
  function escapeHtml(value){
    return String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  }
  function formatMoney(cents,format){
    if(window.Shopify&&typeof window.Shopify.formatMoney==='function')return window.Shopify.formatMoney(cents,format);
    const amount=(Number(cents||0)/100).toFixed(2);
    return (format||'${{amount}}').replace('{{amount}}',amount).replace('{{amount_no_decimals}}',String(Math.round(Number(cents||0)/100)));
  }

  function initProductPage(root){
    if(!root||root.dataset.pxpReady==='1')return;
    root.dataset.pxpReady='1';

    const signal=parseJson(root.querySelector('[data-preet-product-signal]'));
    if(signal)mergeSignal(signal,'view');

    const gallery=root.querySelector('[data-pxp-gallery]');
    if(gallery){
      const media=[...gallery.querySelectorAll('[data-pxp-media]')];
      const thumbs=[...gallery.querySelectorAll('[data-pxp-thumb]')];
      const label=gallery.querySelector('[data-pxp-media-label]');
      const show=id=>{
        media.forEach(item=>{
          const active=item.dataset.pxpMedia===String(id);
          item.classList.toggle('is-active',active);
          item.querySelectorAll('video').forEach(video=>{if(!active)video.pause();});
        });
        thumbs.forEach(thumb=>thumb.classList.toggle('is-active',thumb.dataset.pxpThumb===String(id)));
        const activeMedia=media.find(item=>item.dataset.pxpMedia===String(id));
        if(label&&activeMedia){
          const type=activeMedia.dataset.mediaType||'image';
          label.textContent=type==='external_video'?'Video':type.charAt(0).toUpperCase()+type.slice(1);
        }
      };
      thumbs.forEach(thumb=>thumb.addEventListener('click',()=>show(thumb.dataset.pxpThumb)));
      let startX=0;
      gallery.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;startX=e.clientX;});
      gallery.addEventListener('pointerup',e=>{
        const dx=e.clientX-startX;if(Math.abs(dx)<55)return;
        const current=Math.max(0,media.findIndex(item=>item.classList.contains('is-active')));
        const next=dx<0?Math.min(media.length-1,current+1):Math.max(0,current-1);
        if(media[next])show(media[next].dataset.pxpMedia);
      });
    }

    const variants=parseJson(root.querySelector('[data-pxp-variants]'))||[];
    const form=root.querySelector('[data-pxp-product-form]');
    if(form&&variants.length){
      const optionSelects=[...form.querySelectorAll('[data-pxp-option]')];
      const idInput=form.querySelector('[data-pxp-variant-id]');
      const price=root.querySelector('[data-pxp-price]');
      const compare=root.querySelector('[data-pxp-compare]');
      const add=form.querySelector('[data-pxp-add]');
      const addLabel=form.querySelector('[data-pxp-add-label]');
      const moneyFormat=root.dataset.moneyFormat||'${{amount}}';
      const updateVariant=()=>{
        const chosen=optionSelects.map(select=>select.value);
        const variant=variants.find(item=>item.options.every((value,index)=>value===chosen[index]))||variants[0];
        if(!variant)return;
        if(idInput)idInput.value=variant.id;
        if(price)price.textContent=formatMoney(variant.price,moneyFormat);
        if(compare){
          const onSale=variant.compare_at_price&&variant.compare_at_price>variant.price;
          compare.classList.toggle('is-hidden',!onSale);
          compare.textContent=onSale?formatMoney(variant.compare_at_price,moneyFormat):'';
        }
        if(add){add.disabled=!variant.available;}
        if(addLabel)addLabel.textContent=variant.available?'Add to bag':'Sold out';
        const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      };
      optionSelects.forEach(select=>select.addEventListener('change',updateVariant));
      const qty=form.querySelector('[data-pxp-qty]');
      form.querySelector('[data-pxp-qty-minus]')?.addEventListener('click',()=>{qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);});
      form.querySelector('[data-pxp-qty-plus]')?.addEventListener('click',()=>{qty.value=(parseInt(qty.value,10)||1)+1;});
    }
  }

  function productFromCard(card){
    return {
      handle:card.dataset.handle||handleFromUrl(card.href),
      title:card.querySelector('h3')?.textContent.trim()||'',
      url:card.getAttribute('href')||'',
      image:card.querySelector('img')?.currentSrc||card.querySelector('img')?.src||'',
      price:card.querySelector('.pxpr-card__copy p')?.textContent.trim()||'',
      vendor:card.dataset.vendor||card.querySelector('.pxpr-card__copy span')?.textContent.trim()||'',
      type:card.dataset.type||''
    };
  }
  function buildHistoryCard(item){
    const link=document.createElement('a');
    link.className='pxpr-card pxpr-card--history';
    let baseUrl=item.url||('/products/'+item.handle);
    if(baseUrl.indexOf('/products/')>-1&&baseUrl.indexOf('view=')===-1){
      baseUrl+= (baseUrl.indexOf('?')>-1?'&':'?')+'view=preet-bottle';
    }
    link.href=baseUrl;
    link.dataset.pxprCard='';link.dataset.handle=item.handle||'';link.dataset.vendor=item.vendor||'';link.dataset.type=item.type||'';link.dataset.nativeRank='99';
    link.innerHTML='<div class="pxpr-card__media preet-media-surface"><img class="preet-product-image" loading="lazy" src="'+escapeHtml(item.image)+'" alt="'+escapeHtml(item.title)+'"></div><div class="pxpr-card__copy"><span>'+escapeHtml(item.vendor)+'</span><h3>'+escapeHtml(item.title)+'</h3><p>'+escapeHtml(item.price)+'</p></div>';
    return link;
  }
  function personalizeRail(root){
    const rail=root.querySelector('[data-pxpr-rail]');if(!rail||rail.dataset.pxprReady==='1')return;
    rail.dataset.pxprReady='1';
    const current=parseJson(root.querySelector('[data-preet-current-product]'))||{};
    const history=readSignals();
    const byHandle=new Map(history.map(item=>[item.handle,item]));
    const vendorAffinity={};const typeAffinity={};
    history.forEach(item=>{
      const weight=(item.views||0)+(item.clicks||0)*2;
      if(item.vendor)vendorAffinity[item.vendor]=(vendorAffinity[item.vendor]||0)+weight;
      if(item.type)typeAffinity[item.type]=(typeAffinity[item.type]||0)+weight;
    });
    let cards=[...rail.querySelectorAll('[data-pxpr-card]')];
    cards.sort((a,b)=>{
      const score=card=>{
        const signal=byHandle.get(card.dataset.handle)||{};
        const nativeRank=Number(card.dataset.nativeRank||0);
        return 100-nativeRank*4+(signal.views||0)*3+(signal.clicks||0)*7+(vendorAffinity[card.dataset.vendor]||0)*1.5+(typeAffinity[card.dataset.type]||0)*1.3+(card.dataset.vendor&&card.dataset.vendor===current.vendor?8:0)+(card.dataset.type&&card.dataset.type===current.type?7:0);
      };
      return score(b)-score(a);
    });
    cards.forEach(card=>rail.appendChild(card));
    const limit=Number(root.dataset.limit||8);
    const existing=new Set(cards.map(card=>card.dataset.handle));
    history.filter(item=>item.handle&&item.handle!==current.handle&&!existing.has(item.handle)&&item.image).slice(0,Math.max(0,limit-cards.length)).forEach(item=>rail.appendChild(buildHistoryCard(item)));
    root.querySelector('[data-pxpr-prev]')?.addEventListener('click',()=>rail.scrollBy({left:-Math.max(280,rail.clientWidth*.72),behavior:'smooth'}));
    root.querySelector('[data-pxpr-next]')?.addEventListener('click',()=>rail.scrollBy({left:Math.max(280,rail.clientWidth*.72),behavior:'smooth'}));
    let down=false,start=0,scrollStart=0,moved=false;
    rail.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;down=true;start=e.clientX;scrollStart=rail.scrollLeft;moved=false;rail.classList.add('is-dragging');rail.setPointerCapture?.(e.pointerId);});
    rail.addEventListener('pointermove',e=>{if(!down)return;const dx=e.clientX-start;if(Math.abs(dx)>5)moved=true;rail.scrollLeft=scrollStart-dx;});
    const end=()=>{down=false;rail.classList.remove('is-dragging');setTimeout(()=>moved=false,0);};
    rail.addEventListener('pointerup',end);rail.addEventListener('pointercancel',end);
    rail.addEventListener('click',e=>{if(moved)e.preventDefault();},true);
  }
  function buildHistoryOnlyRail(root){
    if(root.querySelector('[data-pxpr-rail]'))return true;
    const current=parseJson(root.querySelector('[data-preet-current-product]'))||{};
    const history=readSignals().filter(item=>item.handle&&item.handle!==current.handle&&item.image);
    if(!history.length){root.hidden=true;return false;}
    root.innerHTML='<div class="pxpr__inner"><div class="pxpr__head"><div><span>'+escapeHtml(root.dataset.eyebrow||'Selected around your taste')+'</span><h2>'+escapeHtml(root.dataset.heading||'You might also like.')+'</h2><p>'+escapeHtml(root.dataset.description||'Recently viewed bottles selected around your interests.')+'</p></div><div class="pxpr__controls"><button type="button" data-pxpr-prev aria-label="Previous recommendations">←</button><button type="button" data-pxpr-next aria-label="Next recommendations">→</button></div></div><div class="pxpr__rail" data-pxpr-rail tabindex="0"></div></div>';
    const rail=root.querySelector('[data-pxpr-rail]');
    history.slice(0,Number(root.dataset.limit||8)).forEach(item=>rail.appendChild(buildHistoryCard(item)));
    return true;
  }
  async function initRecommendations(root){
    if(!root||root.dataset.fetching==='1')return;
    if(root.querySelector('[data-pxpr-rail]')){personalizeRail(root);return;}
    const url=root.dataset.url;
    if(!url){if(buildHistoryOnlyRail(root))personalizeRail(root);return;}
    root.dataset.fetching='1';
    try{
      const response=await fetch(url);
      if(response.ok){
        const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');
        const replacement=doc.querySelector('[data-preet-recommendations]');
        if(replacement)root.innerHTML=replacement.innerHTML;
      }
      if(!root.querySelector('[data-pxpr-rail]'))buildHistoryOnlyRail(root);
      personalizeRail(root);
    }catch(e){
      console.warn('Preet recommendations could not be loaded.',e);
      if(buildHistoryOnlyRail(root))personalizeRail(root);
    }
  }
  function boot(scope=document){
    scope.querySelectorAll('[data-preet-product-root]').forEach(initProductPage);
    scope.querySelectorAll('[data-preet-recommendations]').forEach(initRecommendations);
  }
  document.addEventListener('DOMContentLoaded',()=>boot());
  document.addEventListener('shopify:section:load',event=>boot(event.target));
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href*="/products/"]');
    if(!link)return;
    const handle=handleFromUrl(link.href);if(handle)mergeSignal({handle,url:link.getAttribute('href')},'click');
  },true);
})();
